module.exports = __webpack_public_path__ + "static/media/upp_flo_sit_spe_met.18d65935.png";